import * as THREE from 'three'

import MatcapMaterial from '../Materials/Matcap.js'

export default class Materials
{
    constructor(_options)
    {
        this.items = {}
        this.shades = { items: {} }
        const names = ['beige', 'black', 'blue', 'brown', 'copperMetal', 'emeraldGreen', 'goldMetal', 'gray', 'green', 'metal', 'orange', 'purple', 'red', 'white', 'yellow']

        for(const name of names)
        {
            const resourceName = `matcap${name[0].toUpperCase()}${name.slice(1)}Texture`
            const material = new MatcapMaterial()
            material.name = `shade${name[0].toUpperCase()}${name.slice(1)}`
            material.uniforms.matcap.value = _options.resources.items[resourceName]
            material.uniforms.uRevealProgress.value = 1
            material.uniforms.uIndirectDistanceAmplitude.value = 1.75
            material.uniforms.uIndirectDistanceStrength.value = 0.5
            material.uniforms.uIndirectDistancePower.value = 2
            material.uniforms.uIndirectAngleStrength.value = 1.5
            material.uniforms.uIndirectAngleOffset.value = 0.6
            material.uniforms.uIndirectAnglePower.value = 1
            material.uniforms.uIndirectColor.value = new THREE.Color('#d04500')
            this.shades.items[name] = material
            this.items[name] = material
        }
    }
}
